/**
 * №22.3.2 (F2b) — markdown → PLAIN TEXT, for the surfaces that are LISTS.
 *
 * `ChatMarkdown` is the one renderer for chat-visible text (P2). A list row is not
 * chat-visible text: it is a one-line label for something you open. Rendering markdown
 * there would make a row look like a message; printing the raw source there leaks the
 * literal `**` David saw in the panel ("I'm the **Billing Clerk**"). So a row gets
 * neither — it gets the prose with the markup taken off and the length capped.
 *
 * Deliberately small and lossy: it exists to make a LABEL, not to render a document.
 */

/** Strip markdown/emoji-noise to a single, trimmed line of prose. */
export function toPlainText(input: string | null | undefined): string {
  if (!input) return "";
  return input
    .replace(/```[\s\S]*?```/g, " ")               // fenced code
    .replace(/`([^`]*)`/g, "$1")                   // inline code
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")      // images → alt
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")       // links → text
    .replace(/^\s{0,3}#{1,6}\s+/gm, "")            // headings
    .replace(/^\s{0,3}>\s?/gm, "")                 // block quotes
    .replace(/^\s*[-*+]\s+/gm, "")                 // bullets
    .replace(/^\s*\d+\.\s+/gm, "")                 // ordered items
    .replace(/(\*\*\*|___)(.*?)\1/g, "$2")         // bold+italic
    .replace(/(\*\*|__)(.*?)\1/g, "$2")            // bold
    .replace(/(\*|_)(.*?)\1/g, "$2")               // italic
    .replace(/~~(.*?)~~/g, "$1")                   // strikethrough
    .replace(/^\s*([-*_]\s*){3,}$/gm, " ")         // horizontal rules
    .replace(/\|/g, " ")                           // table pipes
    .replace(/\s+/g, " ")
    .trim();
}

/** A list-row label: plain, single-line, and capped so one long reply can never
 *  stretch a row into something that reads like a message. */
export function toRowLabel(input: string | null | undefined, max = 160): string {
  const text = toPlainText(input);
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}
